<template>
  <div class="judge-card">
    <div class="card-header">
      <div class="title-wrap">
        <h4 class="title">{{title || '判断题'}}</h4>
        <div class="editor">
          <el-switch v-model="editTypes"
                     active-text="百度编辑器"
                     inactive-text="默认编辑器"
                     @change="editChange">
          </el-switch>

        </div>
      </div>
      <div class="menu-wrap">
        <slot></slot>
      </div>
    </div>
    <div class="exam-description">
      <VueEditor v-if="!editTypes"
                 :content="description"
                 @change="handleItemDescriptionChange"
                 placeholder="请输入题目，为确保智能组卷功能，题目中无需输入序号数字" />
      <UEeditor v-else
                :setDataStr="description"
                @change="handleItemDescriptionChange" />
    </div>
    <div class="formula"
         v-if="description.includes('$')">
      <div class="top">检测到包含LaTex公式，预览如下</div>
      <div class="bottom">
        <LatexRenderer :content="description" />
      </div>
    </div>
    <div class="exam-option">
      <div class="option-item"
           v-for="(item, $index) in options"
           :key="item.id">
        <div class="left">
          <span class="label">{{keys[$index]}}</span>
          <div class="input-box">
            <VueEditor :content="item.description"
                       :simple="true"
                       @change="handleAnswerDescriptionChange($event, $index)"
                       placeholder="请输入答案选项" />
          </div>
          <div class="result">
            <el-checkbox v-model="item.true_option"
                         @change="handleOptionChange($event, $index)">正确答案</el-checkbox>
          </div>
        </div>
        <div class="right">
          <div class="action-wrap">
            <div v-if="$index != 0">
              <el-button type="text"
                         @click="handleOptionSortChange($index, 'up')">上移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <div v-if="$index != options.length-1">
              <el-button type="text"
                         @click="handleOptionSortChange($index, 'down')">下移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <div v-if="options.length>2">
              <el-button type="text"
                         @click="handleOptionRemove(item, $index)">删除</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <div v-if="$index == options.length-1">
              <el-button type="text"
                         @click="handleOptionAdd">新增</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="exam-parse">
      <VueEditor v-if="!editTypes"
                 :content="solveGuide"
                 @change="handleSolveGuideChange"
                 placeholder="请输入答案解析" />
      <UEeditor v-else
                :setDataStr="solveGuide"
                @change="handleSolveGuideChange" />
    </div>
    <div class="formula"
         v-if="solveGuide.includes('$')">
      <div class="top">检测到包含LaTex公式，预览如下</div>
      <div class="bottom">
        <LatexRenderer :content="solveGuide" />
      </div>
    </div>
    <div class="exam-parse">
      <el-input class="video-url"
                v-model="videoUrl"
                placeholder="视频解析地址"
                @change="handleItemVideoUrlChange"></el-input>
    </div>
    <specials :visible="dialogVisible"
              @echo="echo"
              :content="content"
              @readName="readName"
              @close="dialogVisible = false">
    </specials>
    <div class="zhi"
         @click="concatStudy()">选择关联知识点：
      <el-tag v-if="nameflag"> {{nameflag}}</el-tag>
    </div>
  </div>
</template>

<script>
import LatexRenderer from '@/components/formula/formulaGeneration.vue'
import VueEditor from '@/components/VueEditor'
import UEeditor from '@/components/UEeditor.vue'
import {
  examItemUpdate,
  examAnswerCreate,
  examAnswerUpdate,
  examAnswersUpdate,
  examAnswerDestroy,
} from '@/api/exam'

let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长

export default {
  components: {
    LatexRenderer,
    specials: () => import('@/components/exam/special.vue'),
    VueEditor,
    UEeditor,
  },
  props: {
    title: String,
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
    itemList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      editTypes: false,
      dialogVisible: false,
      keys: `ABCDEFGHIJKLMNOPQRSTUVWXYZ`.split(''),
      description: this.content.description || '',
      solveGuide: this.content.solve_guide || '',
      videoUrl: this.content.video_analysis_url || '',
      options: this.content.options || [],
      nameflag: '',
      filterItem: [],
    }
  },
  watch: {
    itemList: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.filterItem = this.itemList.filter(
            (v) => v.item_id == this.content.item_id
          )

          setTimeout(() => {
            this.nameflag = this.filterItem[0].readName
          }, 500)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    editChange(val) {
      this.editTypes = val
    },
    concatStudy() {
      this.dialogVisible = true
      // this.$refs.childLevelRelevancy.open(this.id, 2)
    },
    readName(val) {
      this.$set(this.content, 'readName', val)
      this.$emit('shuxin')
    },
    echo(val, item) {
      this.concatItem = item.name
      this.cncatId = item.id
    },
    // 正确答案变化
    handleOptionChange(value, index) {
      if (value) {
        this.options.forEach((item, i) => {
          if (i !== index) {
            item.true_option = false
          }
        })
      }
      const rows = this.options.map((item) => {
        return { id: item.id, true_option: item.true_option ? 1 : 0 }
      })
      examAnswersUpdate(rows)
        .then((res) => {
          // 数据向外层传递
          this.handleExamSave()
        })
        .catch((error) => {
          this.$message.error('正确答案项设置异常')
          console.log('error: ', error)
        })
    },
    // 新增选项
    handleOptionAdd() {
      let newAnswer = {
        item_id: this.content.item_id,
        description: '',
        true_option: 0,
        sort: this.options.length,
      }
      examAnswerCreate(newAnswer)
        .then((res) => {
          this.options.push(res)

          // 数据向外层传递
          this.handleExamSave()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    // 删除选项
    handleOptionRemove(item, index) {
      // 二次确认撤销
      this.$confirm(
        '确定要删除吗？题目被多处引用时，进行删除操作可能会产生不良影响，请谨慎操作。',
        '提示',
        {
          confirmButtonText: '确定删除',
          type: 'warning',
        }
      )
        .then(() => {
          examAnswerDestroy({ id: item.id })
            .then((res) => {
              this.options.splice(index, 1)
              // 数据向外层传递
              this.handleExamSave()
            })
            .catch((error) => {
              this.$message.error('答案项删除失败')
              console.log('error: ', error)
            })
        })
        .catch(() => {})
    },
    // 排序选项
    handleOptionSortChange(index, type) {
      let old = this.options.splice(index, 1)[0]
      if (type == 'up') {
        this.options.splice(index - 1, 0, old)
      } else if (type == 'down') {
        this.options.splice(index + 1, 0, old)
      }
      const rows = this.options.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      examAnswersUpdate(rows)
        .then((res) => {
          // 数据向外层传递
          this.handleExamSave()
        })
        .catch((error) => {
          this.$message.error('答案项排序更新异常')
          console.log('error: ', error)
        })
    },
    // 答案项描述变动
    handleAnswerDescriptionChange(editor, index) {
      this.options[index].description = editor.html
      let row = {
        id: this.options[index].id,
        description: this.options[index].description,
      }
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examAnswerUpdate(row)
          .then((res) => {
            // 数据向外层传递
            this.handleExamSave()
          })
          .catch((error) => {
            this.$message.error('答案项描述更新异常')
            console.log('error: ', error)
          })
      }, TimerTime)
    },
    // 题目描述变动
    handleItemDescriptionChange(editor) {
      if (this.editTypes) {
        this.description = editor
      } else {
        this.description = editor.html
      }

      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examItemUpdate({
          id: this.content.item_id,
          description: this.description,
        })
          .then((res) => {
            // 数据向外层传递
            this.handleExamSave()
          })
          .catch((error) => {
            this.$message.error('题目描述更新异常')
            console.log('error: ', error)
          })
      }, TimerTime)
    },
    // 题目解析更新
    handleSolveGuideChange(editor) {
      if (this.editTypes) {
        this.solveGuide = editor
      } else {
        this.solveGuide = editor.html
      }
      // this.solveGuide = editor.html
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examItemUpdate({
          id: this.content.item_id,
          solve_guide: this.solveGuide,
        })
          .then((res) => {
            // 数据向外层传递
            this.handleExamSave()
          })
          .catch((error) => {
            this.$message.error('题目描述更新异常')
            console.log('error: ', error)
          })
      }, TimerTime)
    },
    // 视频解析地址更新
    handleItemVideoUrlChange(value) {
      this.videoUrl = value
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examItemUpdate({
          id: this.content.item_id,
          video_analysis_url: this.videoUrl,
        })
          .then((res) => {
            // 数据向外层传递
            this.handleExamSave()
          })
          .catch((error) => {
            this.$message.error('视频解析地址更新异常')
            console.log('error: ', error)
          })
      }, TimerTime)
    },
    handleExamSave() {
      this.$emit('save', {
        description: this.description,
        solve_guide: this.solveGuide,
        options: this.options,
      })
    },
  },
}
</script>

<style scoped lang="less">
.zhi {
  margin-top: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #0091ff;
  font-size: 16px;
}
.judge-card {
  position: relative;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  background: #f2f2f2;
  padding: 20px;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .title-wrap {
      display: flex;
      align-items: center;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #0091ff;
        margin-right: 20px;
      }
      .editor {
        position: absolute;
        left: 65%;
      }
    }
    .menu-wrap {
      display: flex;
      align-items: center;

      /deep/ .el-button {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  .vueEditor {
    /deep/ .ql-container {
      min-height: 80px;
    }
  }
  .formula {
    width: 100%;
    background: #f9f9f9;
    border: 1px solid #d4d1d1;
    .top {
      font-weight: 700;
      padding-left: 15px;
      width: 100%;
      line-height: 68px;
      border-bottom: 1px solid #d4d1d1;
    }
    .bottom {
      width: 100%;
      min-height: 80px;
      max-height: 300px;
      overflow-y: auto;
    }
  }
  .exam-option {
    background: #fff;
    padding: 20px;
    margin-top: 10px;
  }
  .option-item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & + .option-item {
      margin-top: 10px;
    }
    .left {
      display: flex;
      align-items: center;
    }
    .label {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      color: #0091ff;
      border-radius: 12px;
      border: 1px solid #0091ff;
      margin-right: 10px;
    }
    .input-box {
      width: 500px;
    }
    .result {
      margin-left: 10px;
    }

    .right {
      display: flex;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: center;
      width: 115px;

      > div:last-child {
        .divider {
          display: none;
        }
      }
    }
  }

  .exam-parse {
    margin-top: 10px;

    .video-url /deep/ input {
      border-radius: 0;
      border-color: #c0c4cc;

      &:focus {
        border-color: #c0c4cc;
      }
    }
  }
}
</style>
